import { FORM_VALIDATIONS } from '@riseart/form';
import { dialingCodes as DIALING_CODES } from 'Countries';

export const EnquireOfferFormModel = ({
  maxAllowedDiscountPercent,
  productPrice,
  formatMessage,
}) => ({
  settings: {
    hideRequiredMark: true,
    layout: 'horizontal',
  },
  fields: [
    {
      tag: 'input',
      type: 'email',
      name: 'email',
      validateTrigger: 'onBlur',
      rules: [
        {
          type: 'email',
          message: 'forms.common.validation_messages.not_valid_email',
        },
        {
          required: true,
          message: 'forms.common.validation_messages.not_empty_email',
        },
      ],
      label: 'forms.emailEnquire.placeholder.email',
    },
    {
      tag: 'input',
      type: 'text',
      name: 'firstName',
      validateTrigger: 'onBlur',
      rules: [
        {
          required: true,
          message: 'forms.common.validation_messages.not_empty_first_name',
        },
        {
          pattern: "^[a-zA-ZÀÁÂÄÇÈÉÊÌÍÒÓÖÔÜàáäâçèéêìíòóöôüß'-\\s]*$",
          message: 'forms.common.validation_messages.not_valid_first_name',
        },
      ],
      label: 'forms.emailEnquire.placeholder.firstName',
    },
    {
      tag: 'input',
      type: 'text',
      name: 'lastName',
      validateTrigger: 'onBlur',
      rules: [
        {
          required: true,
          message: 'forms.common.validation_messages.not_empty_last_name',
        },
        {
          pattern: "^[a-zA-ZÀÁÂÄÇÈÉÊÌÍÒÓÖÔÜàáäâçèéêìíòóöôüß'-\\s]*$",
          message: 'forms.common.validation_messages.not_valid_last_name',
        },
      ],
      label: 'forms.emailEnquire.placeholder.lastName',
    },
    {
      tag: 'phone',
      type: 'phone',
      name: 'phone',
      validateTrigger: 'onBlur',
      rules: [
        ...FORM_VALIDATIONS.PHONE,
        {
          required: true,
          message: 'forms.common.validation_messages.required',
        },
      ],
      label: 'forms.emailEnquire.placeholder.phone',
      dialingCodes: DIALING_CODES,
      initialCountryCode: 'gb',
    },
    {
      tag: 'input',
      type: 'text',
      name: 'productPrice',
      validateTrigger: 'onBlur',
      disabled: true,
      label: 'forms.emailEnquire.placeholder.productPrice',
      prefix: (props) =>
        props && props.customData && props.customData.currencySign
          ? props.customData.currencySign
          : null,
    },
    {
      tag: 'input',
      type: 'text',
      name: 'offer',
      validateTrigger: 'onBlur',
      rules: [
        {
          required: true,
          message: 'forms.common.validation_messages.required',
        },
        {
          message: 'forms.common.validation_messages.notValidOffer',
          validator: (_, offerPrice) => {
            if (
              !offerPrice ||
              !productPrice ||
              (offerPrice < productPrice &&
                offerPrice &&
                100 * (1 - offerPrice / productPrice) <= maxAllowedDiscountPercent)
            ) {
              // eslint-disable-next-line
              return Promise.resolve();
            }

            // eslint-disable-next-line
            return Promise.reject(
              formatMessage({ id: 'forms.common.validation_messages.notValidOffer' }),
            );
          },
        },
      ],
      label: 'forms.emailEnquire.placeholder.offer',
      prefix: (props) =>
        props && props.customData && props.customData.currencySign
          ? props.customData.currencySign
          : null,
    },
    {
      tag: 'textarea',
      name: 'message',
      label: 'forms.emailEnquire.placeholder.message',
      maxLength: 512,
    },
  ],
});
